module.exports = __webpack_public_path__ + "media/images/team_raj-e66ae16e.jpg";